// AUTO-GENERATED by scripts/generate-widget-registry.sh — DO NOT EDIT

import { definition as capexCaptureDef } from './items/data-provider/CAPEX_CAPTURE';
import { definition as companyEarningsDef } from './items/data-provider/COMPANY_EARNINGS';
import { definition as companyProfileDef } from './items/data-provider/COMPANY_PROFILE';
import { definition as compsDef } from './items/data-provider/COMPS';
import { definition as consensusRevisionDef } from './items/data-provider/CONSENSUS_REVISION';
import { definition as consensusTableDef } from './items/data-provider/CONSENSUS_TABLE';
import { definition as correlationDef } from './items/data-provider/CORRELATION';
import { definition as earningsSurpriseDef } from './items/data-provider/EARNINGS_SURPRISE';
import { definition as financialsDef } from './items/data-provider/FINANCIALS';
import { definition as forwardValuationDef } from './items/data-provider/FORWARD_VALUATION';
import { definition as insyncModelDef } from './items/data-provider/INSYNC_MODEL';
import { definition as positionRiskDef } from './items/data-provider/POSITION_RISK';
import { definition as priceDef } from './items/data-provider/PRICE';
import { definition as priceTargetsDef } from './items/data-provider/PRICE_TARGETS';
import { definition as shortInterestDef } from './items/data-provider/SHORT_INTEREST';
import { definition as valuationTableDef } from './items/data-provider/VALUATION_TABLE';
import { definition as varianceTableDef } from './items/data-provider/VARIANCE_TABLE';
import { definition as volumeDef } from './items/data-provider/VOLUME';
import { definition as convictionDef } from './items/input/conviction';
import { definition as probabilityForecastDef } from './items/input/probability_forecast';
import { definition as qaDef } from './items/input/qa';
import { definition as scorecardDef } from './items/input/scorecard';
import { definition as tradingScoreDef } from './items/input/trading_score';
import { definition as onedriveDef } from './items/microsoft/onedrive';
import { definition as outlookDef } from './items/microsoft/outlook';
import { definition as dashboardReferenceDef } from './items/reference/dashboard_reference';
import { definition as imageRepositoryDef } from './items/repository/image_repository';
import { definition as notesRepositoryDef } from './items/repository/notes_repository';
import { definition as pdfRepositoryDef } from './items/repository/pdf_repository';

// All widget definitions (sorted by file path)
export const definitions = [
  capexCaptureDef,
  companyEarningsDef,
  companyProfileDef,
  compsDef,
  consensusRevisionDef,
  consensusTableDef,
  correlationDef,
  earningsSurpriseDef,
  financialsDef,
  forwardValuationDef,
  insyncModelDef,
  positionRiskDef,
  priceDef,
  priceTargetsDef,
  shortInterestDef,
  valuationTableDef,
  varianceTableDef,
  volumeDef,
  convictionDef,
  probabilityForecastDef,
  qaDef,
  scorecardDef,
  tradingScoreDef,
  onedriveDef,
  outlookDef,
  dashboardReferenceDef,
  imageRepositoryDef,
  notesRepositoryDef,
  pdfRepositoryDef,
];
